module.exports = __webpack_public_path__ + "img/flagSprite42.dbb8da18.png";